// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledInput,
  StyledInputClasses,
  StyledLabel,
  StyledLabelClasses,
  StyledFormControl,
  StyledFormControlClasses
} from './DatePickerField.styles';

/**
 * Generic input field
 */
function DatePickerField(props) {
  const {
    labelText,
    name,
    placeholder,
    id,
    value,
    borderTheme,
    disableDatePicker,
    onBlurHook,
    onChangeHook,
    onFocusHook
  } = props;

  const onBlur = (e) => {
    if (onBlurHook) onBlurHook(e);
  };

  const onChange = (e) => {
    if (onChangeHook) onChangeHook(e);
  };

  const onFocus = (e) => {
    if (onFocusHook) onFocusHook(e);
  };

  return (
    <StyledFormControl id={id} classes={StyledFormControlClasses}>
      <StyledLabel classes={StyledLabelClasses} htmlFor={name}>
        {labelText}
      </StyledLabel>
      <StyledInput
        borderTheme={borderTheme}
        autoComplete="off"
        classes={StyledInputClasses}
        disabled={disableDatePicker}
        disableUnderline
        name={name}
        value={value}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        readOnly
      />
    </StyledFormControl>
  );
}

DatePickerField.propTypes = {
  /** HTML ID attribute */
  id: PropTypes.string,

  /** Border Type */
  borderTheme: PropTypes.string,

  /** Boolean to disable the datepicker input */
  disableDatePicker: PropTypes.bool,

  /** Label text to show */
  labelText: PropTypes.string,

  /** HTML Name attribute */
  name: PropTypes.string,

  /** onBlur function */
  onBlurHook: PropTypes.func,

  /** onChange function */
  onChangeHook: PropTypes.func,

  /** onFocus fucntion */
  onFocusHook: PropTypes.func,

  /** Placeholder text to show. Displays after shrink animation */
  placeholder: PropTypes.string,

  /** Value */
  value: PropTypes.string
};

DatePickerField.defaultProps = {
  id: undefined,
  borderTheme: 'default',
  disableDatePicker: false,
  labelText: undefined,
  name: undefined,
  onBlurHook: () => {},
  onChangeHook: () => {},
  onFocusHook: () => {},
  placeholder: undefined,
  value: ''
};

export default DatePickerField;
